import { Slide } from '@/components/slides/Slide.tsx';
import React, { FC, useEffect, useState } from 'react';
import { Slide as SlideType } from '@/eventConfig/types.ts';
import { GridInput } from '@/components/slides/GridScanner/GridInput.tsx';
import { useLayer } from '@/layers/useLayer.tsx';
import { useEventConfig } from '@/eventConfig/useEventConfig.ts';

interface BarcodeScannerSlideProps {
  className?: string;
  slide: SlideType;
}

export const GridScannerSlide: FC<BarcodeScannerSlideProps> = ({ slide }) => {
  const { showLayer, layerState } = useLayer();
  const { eventConfig } = useEventConfig();
  const [scannerEnabled, setScannerEnabled] = useState(false);
  const [awaitingIntroLayers, setAwaitingIntroLayers] = useState(false);
  const [introLayerSeen, setIntroLayerSeen] = useState(false);

  useEffect(() => {
    setScannerEnabled(false);
    setAwaitingIntroLayers(false);
    setIntroLayerSeen(false);

    if (eventConfig?.meta?.demo) {
      setAwaitingIntroLayers(true);
      showLayer({ ref: '@demoScanGridNotice' });
      return;
    }

    if (slide.enter?.type === 'layer') {
      setScannerEnabled(true);
      return;
    }

    setAwaitingIntroLayers(true);
    showLayer({ ref: '@allowCameraHint' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventConfig?.meta?.demo, slide.enter]);

  useEffect(() => {
    if (!awaitingIntroLayers) {
      return;
    }

    if (layerState === 'visible') {
      setIntroLayerSeen(true);
      return;
    }

    if (introLayerSeen && layerState === 'closed') {
      setScannerEnabled(true);
      setAwaitingIntroLayers(false);
      setIntroLayerSeen(false);
    }
  }, [awaitingIntroLayers, introLayerSeen, layerState]);

  return (
    <Slide className={'type-barcode'} slide={slide}>
      <GridInput scannerEnabled={scannerEnabled} />
    </Slide>
  );
};
